<!-- Transfer PID -->
<fsmodal [show]="show" [closable]=true (closed)="modal.transferPID = false;" class="transfer-pid-component">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.TRANSFER_PID')}} </div>
    <div class="modal-body-content">
        <div>
            <nestas-toolbar [modal]="modal"></nestas-toolbar>
        </div>
        <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid"></nestas-pidinfo>

        <div class="wrap" *ngIf="modal && modal.pid">

            <!--*ngIf="!modal.pid.sharedWith || !modal.pid.sharedWith.length"-->
            <mat-card-subtitle [innerHTML]="infoicon() + translate.instant('PID_CARD.TRANSFER_SUBTITLE')"  class="alert-info">
                
            </mat-card-subtitle>
            <br />
            <br />
            <!--<mat-card-subtitle *ngIf="!modal.pid.sharedWith || modal.pid.sharedWith.length" class="alert-info">
                <i class="material-icons ic-info">info</i>{{translate.instant('PID_CARD.ALREADY_SHARED')}}
            </mat-card-subtitle>-->

            <div class="datatable-wrap" *ngIf="rows.length">
                <ngx-datatable class="bootstrap" [rows]="rows" [rowHeight]="40" [headerHeight]="30">
                    <ngx-datatable-column [width]="250" name="{{translate.instant('DATA.STATUS')}}" prop="status">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="top-pad" *ngIf="row.type == 'shared'">
                                {{translate.instant('PID_CARD.ALREADY_SHARED')}} <span
                                    *ngIf="row.transferSubType">({{row.transferSubType}})</span>
                            </div>
                            <div class="top-pad" *ngIf="row.type == 'shared_pending'">
                                {{translate.instant('PID_CARD.SHARED_PENDING')}}
                            </div>
                            <div class="top-pad" *ngIf="row.type == 'readonly_pending'">
                                {{translate.instant('PID_CARD.TRANSFER_PENDING')}}
                            </div>
                            <div class="top-pad" *ngIf="row.type == 'readonly' && row.copy">
                                {{translate.instant('PID_CARD.TRANSFERRED')}}
                            </div>
                            <div class="top-pad" *ngIf="row.type == 'readonly' && !row.copy">
                                {{translate.instant('PID_CARD.RECEIVED_FROM')}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [width]="175" name="{{translate.instant('DATA.EMAIL')}}" prop="email">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="top-pad">
                                {{row.email}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <!--<ngx-datatable-column name="{{translate.instant('DATA.NAME')}}" prop="name">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div>
                                N {{row.name ? row.name : ''}} F {{row?.firstname}} L {{row?.lastname}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>-->

                    <ngx-datatable-column [width]="175" name="{{translate.instant('DATA.DATETIME')}}" prop="company">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="top-pad">
                                {{row.date| date: 'dd/MM/yyyy HH:mm:ss'}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column [width]="250" name="{{translate.instant('NEW_FILE.TRANSFER.TYPE')}}" prop="company">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div *ngIf="(!modal.pid.copy || modal.pid.transferTo.pending)">
                                <button mat-stroked-button *ngIf="row.type == 'readonly_pending'"
                                    (click)="initTransferPID(transferEmailForm.get('transferEmail').value, 'unreadonly')">
                                    {{translate.instant('NEW_FILE.TRANSFER.UNREADONLY')}}</button>
                                <button mat-stroked-button *ngIf="row.type == 'shared' || row.type == 'shared_pending' "
                                    (click)="initTransferPID(transferEmailForm.get('transferEmail').value, 'unshare')">
                                    {{translate.instant('NEW_FILE.TRANSFER.UNSHARE')}}</button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>
            </div>

            <form *ngIf="editable" class="full-width-form" style="margin-top:40px;" [formGroup]="transferEmailForm" validate>

                <div class="datatable-wrap">
                    <ngx-datatable class="bootstrap" [rows]="transferRow" [rowHeight]="40" [headerHeight]="10">
                        <ngx-datatable-column [width]="250" name="{{translate.instant('DATA.EMAIL')}}" prop="email">
                            <ng-template ngx-datatable-cell-template>

                                <mat-form-field>
                                    <input matInput formControlName="transferEmail" name="transfer_target_email"
                                        type="email" email required 
                                        [placeholder]="" class="control-width">
                                </mat-form-field>
                                
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column [width]="350" name="{{translate.instant('NEW_FILE.TRANSFER.TYPE')}}"
                            prop="type">
                            <ng-template ngx-datatable-cell-template>
                                <mat-form-field>
                                    <mat-select matNativeControl formControlName="transferType" name="transferType" required>
                                        <mat-option *ngIf="!(modal.pid.transferTo?.transferType == 'shared' && modal.pid.sharedWith?.length)"
                                            [value]="'readonly'">
                                            {{translate.instant('NEW_FILE.TRANSFER.READONLY')}}</mat-option>
                                        <mat-option *ngIf="modal.pid.transferTo?.transferType == 'readonly'"
                                            [value]="'unreadonly'">
                                            {{translate.instant('NEW_FILE.TRANSFER.UNREADONLY')}}</mat-option>
                                        <mat-option *ngIf="modal.pid.transferTo?.transferType != 'readonly'"
                                            [value]="'shared'">
                                            {{translate.instant('NEW_FILE.TRANSFER.SHARED')}}</mat-option>
                                        <mat-option *ngIf="modal.pid.transferTo?.transferType != 'readonly'"
                                            [value]="'shared_ro'">
                                            {{translate.instant('NEW_FILE.TRANSFER.SHARED_RO')}}</mat-option>
                                        <mat-option *ngIf="modal.pid.transferTo?.transferType == 'shared' && modal.pid?.sharedWith?.length"
                                            [value]="'unshare'">
                                            {{translate.instant('NEW_FILE.TRANSFER.UNSHARE')}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="200" name="" prop="type">
                            <ng-template ngx-datatable-cell-template>
                                <button mat-raised-button color="primary" 
                                    [disabled]="transferEmailForm.get('transferEmail').invalid && transferEmailForm.get('transferType').value != 'unreadonly'"
                                    (click)="initTransferPID(transferEmailForm.get('transferEmail').value, transferEmailForm.get('transferType').value)">
                                    {{translate.instant('NEW_FILE.TRANSFER.EXECUTE')}}
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                    
                </div>
              
            </form>

            <div *ngIf="!modal.pid.copy" style="margin-top:40px; margin-bottom:120px;margin-left:600px">
                <button mat-stroked-button
                    (click)="modal.transferPID = false;">{{translate.instant('BUTTON.ACTION.CANCEL')}}
                </button>
            </div>

        </div>
    </div>
</fsmodal>